var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchCarsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 11h2a1 1 0 0 1-1 1H6v-1ZM15 11h-2a1 1 0 0 0 1 1h1v-1Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.523 9A2 2 0 0 0 4 10.348V15a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h7v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4.652A2 2 0 0 0 16.477 9H17.5a.5.5 0 0 0 0-1h-1.9l-1.097-2.743A2 2 0 0 0 12.646 4H8.354a2 2 0 0 0-1.857 1.257L5.4 8H3.5a.5.5 0 0 0 0 1h1.023ZM16 13v-2.652a1 1 0 0 0-.324-.736L15.011 9H5.99l-.666.612a1 1 0 0 0-.324.736V13h11Zm-1.477-5-.949-2.371A1 1 0 0 0 12.646 5H8.354a1 1 0 0 0-.928.629L6.477 8h8.046ZM15 14h1v1h-1v-1Zm-9 0H5v1h1v-1Z",
  fill: "#252829"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.832 18.877A10.454 10.454 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5c0 2.455-.843 4.714-2.255 6.502a1.995 1.995 0 0 1 1.498.584l3.19 3.191a1 1 0 0 1 0 1.414l-1.413 1.414a1 1 0 0 1-1.415 0l-3.19-3.19a1.995 1.995 0 0 1-.583-1.538ZM20 10.5a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Zm-.465 7.793 3.192 3.191-1.415 1.414-3.19-3.19a1 1 0 0 1 1.413-1.415Z",
  fill: "#252829"
})));
export default SvgSearchCarsinline;